import {Controller} from "@hotwired/stimulus"
import Sortable from 'sortablejs';

export default class extends Controller {
    static targets = ['list'];

    connect() {
        const sortable = Sortable.create(this.listTarget, {
            group: 'nested',
            animation: 150,
            fallbackOnBody: true,
            swapThreshold: 0.5,
            onEnd: (evt) => {
                if (evt.newIndex !== evt.oldIndex) {
                    this.updateSortOrder(evt);
                }
            },
            onMove: (evt) => {
                const target = evt.related;
                if (target && target.classList.contains('nested-item')) {
                    evt.dragged.parentNode.removeChild(evt.dragged);
                    target.appendChild(evt.dragged);
                }
            }
        });
    }

    updateSortOrder(evt) {
        const item = evt.item;
        const url = item.dataset.url ;
        const position = evt.newIndex + 1
        const token = document.querySelector('meta[name="csrf-token"]').content;

        fetch(url, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': token
            },
            body: JSON.stringify({position: position})
        });
    }
}